var map = {
	"./Mastercard Symbol - PNG/Artwork/Mastercard Symbol 45px PNG/mc_symbol_opt_45_1x.png": "2929",
	"./Mastercard Symbol - PNG/Artwork/Mastercard Symbol 45px PNG/mc_symbol_opt_45_3x.png": "da37",
	"./Mastercard Symbol - PNG/Artwork/Mastercard Symbol 53px PNG/mc_symbol_opt_53_1x.png": "0040",
	"./Mastercard Symbol - PNG/Artwork/Mastercard Symbol 53px PNG/mc_symbol_opt_53_2x.png": "297a",
	"./Mastercard Symbol - PNG/Artwork/Mastercard Symbol 53px PNG/mc_symbol_opt_53_3x.png": "4f39",
	"./Mastercard Symbol - PNG/Artwork/Mastercard Symbol 63px PNG/mc_symbol_opt_63_1x.png": "8bbcb",
	"./Mastercard Symbol - PNG/Artwork/Mastercard Symbol 63px PNG/mc_symbol_opt_63_2x.png": "6c73",
	"./Mastercard Symbol - PNG/Artwork/Mastercard Symbol 63px PNG/mc_symbol_opt_63_3x.png": "7da6",
	"./Mastercard Symbol - PNG/Artwork/Mastercard Symbol 73px PNG/mc_symbol_opt_73_1x.png": "5714",
	"./Mastercard Symbol - PNG/Artwork/Mastercard Symbol 73px PNG/mc_symbol_opt_73_2x.png": "7ca6",
	"./Mastercard Symbol - PNG/Artwork/Mastercard Symbol 73px PNG/mc_symbol_opt_73_3x.png": "e3f1",
	"./Mastercard Symbol - PNG/mc_brandcenter_READ-ME_200928.pdf": "a895",
	"./Mastercard Symbol - PNG/mc_symbol_web-artwork_qrg_210112.pdf": "324d",
	"./create-orde1r.jpg": "72ed",
	"./create-order.jpg": "8c42",
	"./mc-logo.png": "55f4",
	"./new-agency.jpg": "91e6",
	"./payment-details.jpg": "9217",
	"./payment-history.jpg": "7339",
	"./platinum-visa.png": "e72b",
	"./view-agencies.jpg": "fe4f",
	"./view-order1s.jpg": "9aa5",
	"./view-orders.jpg": "a30e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2a92";